import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

/**
 * Renders a centered semi-transparent overlay with a circular spinner
 * on top of its nearest `position: relative` ancestor.
 * Usage: place inside a container that has `position: relative`.
 */
export default function LoadingOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div style={{
      position: 'absolute',
      top: 0, left: 0, right: 0, bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255, 255, 255, 0.6)',
      zIndex: 10,
      borderRadius: 'inherit',
    }}>
      <CircularProgress />
    </div>
  );
}
